<template>
   <div class="element-combobox">
      <div class="combobox-frame" @click="toggle($event)"></div>
      <div v-if="$store.state.combobox == _uid" class="combobox-list">
        <div class="cmb-mark"></div>
        <ul>
          <template v-if="items.length > 0">
            <li
              v-for="(item, index) in items"
              :class="[item.value == value ? 'active' : '' ]"
              :key="index"
              @click="selectItem(item.value, item, $event)"
            >{{ item.label }}</li>
          </template>
        </ul>
      </div>
    </div>
</template>
<script>
export default {
  props: ["show", "items", "value"],
  date () {
    return {
      _uid: this._uid
    }
  },
  created() {

  },
  methods: {
    toggle(e) {
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      if(this.$store.state.combobox){
        this.$store.commit('SET_COMBOBOXSTATE', null)
      }else{
        this.$store.commit('SET_COMBOBOXSTATE', this._uid)
      }
      
    },
    selectItem( value, item, e){
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      this.$store.commit('SET_COMBOBOXSTATE', null)
      if(!item.placeholder){
        this.$emit( "input", value );
      }
    }
  }
}
</script>